<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu-filter>

            <div class="row mb-2">
              <div class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model="filters.person" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.person") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.gebaeude"
                        :options="gebaeude"
                        label="bezeichnung"
                        :reduce="(g) => g.id"
                        :placeholder="$t('global.hotel')"
                      ></v-select>
                      <label>{{ $t("global.hotel") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input v-model="filters.veranstaltung" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.educationcourseorshortevent") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        :show-icon="true"
                        @updatefull="setFilterDate"
                        :initial="filters.von"
                        field="von"
                      />
                      <label>{{ $t("global.from") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        :show-icon="true"
                        @updatefull="setFilterDate"
                        :initial="filters.bis"
                        field="bis"
                      />
                      <label>{{ $t("global.till") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.reservationstyp"
                        :options="reservationstypen"
                        label="bezeichnung"
                        :reduce="(t) => t.id"
                        :placeholder="$t('global.reservationtype')"
                      ></v-select>
                      <label>{{ $t("global.reservationtype") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.voranreise"
                        :options="jaNeinOptionen"
                        label="bezeichnung"
                        :reduce="(o) => o.id"
                        :placeholder="$t('global.arrivaltheeveningbefore')"
                      ></v-select>
                      <label>{{ $t("global.arrivaltheeveningbefore") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 mb-3">
                    <b-form-checkbox v-model="filters.offen" switch>
                      {{ $t("global.onlywithouthotel") }}
                    </b-form-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group" id="number-of-records">
                      <input v-model="filters.count" class="form-control input" type="text" placeholder=" " />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.roomreservations')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <button class="btn btn-primary" @click="exportRoomingListe">
                      <font-awesome-icon icon="fa-regular fa-file-spreadsheet" class="mr-2" />{{ $t("global.export") }}
                    </button>
                  </div>
                  <div class="mr-4 float-right">
                    <button class="btn btn-danger" @click="oeffneLoeschenModal" v-if="zimmerRecht('delete')">
                      <font-awesome-icon icon="fa-duotone fa-trash" class="mr-2" />{{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <b-table
                  ref="selectableTable"
                  small
                  tbody-tr-class="item"
                  :items="listData"
                  :fields="fields"
                  sort-icon-left
                  fixed
                  selectable
                  select-mode="range"
                  @row-dblclicked="details"
                  thead-tr-class="pointer"
                >
                  <template v-slot:head(selected)="header">
                    <b-form-checkbox
                      ref="headerCheckbox"
                      v-model="header.selected"
                      @input="selectAllRows(header)"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(selected)="row">
                    <b-form-checkbox v-model="row.item.selected" @input="onRowSelected(row)"></b-form-checkbox>
                  </template>
                  <template v-slot:cell(gebaeude)="row">
                    <span v-if="row.item.gebaeude">{{ row.item.gebaeude.bezeichnung }}</span>
                    <b-badge v-else variant="warning">{{ $t("global.hotelopen") }}</b-badge>
                  </template>
                  <template v-slot:cell(voranreise)="row">
                    <font-awesome-icon v-if="row.item.voranreise" icon="fa-solid fa-check" />
                  </template>
                </b-table>

                <infinite-loading :identifier="infiniteId" @infinite="($state) => infiniteHandler($state, 'app-api')">
                  <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                  <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                  <div slot="no-results">{{ $t("global.nofurtherdatafound") }}</div>
                </infinite-loading>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="zimmerreservation-loeschen-modal"
      @confirmed="loeschen"
      :selectedIds="selectedIds"
      :multiple="true"
    />
    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import DatePicker from "@/components/Datepicker";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_RESSOURCEN } from "@/store/ressourcen/actions.type";

import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";
import excelExport from "@/mixins/ExcelExport";

export default {
  name: "Zimmerreservationsliste",
  components: { Navbar, HeadMenu, HeadMenuFilter, LoeschenModal, DatePicker, FilterSearchResetButton },
  metaInfo() {
    return {
      titleTemplate: () => "BX: " + this.$t("global.roomreservations"),
    };
  },
  mixins: [page, dashboard, filter, excelExport],
  store,
  data() {
    return {
      reservationstypen: [],
    };
  },
  computed: {
    gebaeude() {
      return this.$store.state.ressourcen.gebaeude;
    },
    jaNeinOptionen() {
      return [
        { id: "true", bezeichnung: this.$t("global.yes") },
        { id: "false", bezeichnung: this.$t("global.no") },
      ];
    },
    fields() {
      return [
        { key: "selected", label: "" },
        { key: "person.bezeichnung", sortable: true, label: this.$t("global.person") },
        { key: "reservationstyp.bezeichnung", sortable: true, label: this.$t("global.reservationtype") },
        { key: "gebaeude", sortable: true, label: this.$t("global.hotel") },
        { key: "lehrgang.bezeichnung", sortable: true, label: this.$t("global.educationcourse") },
        { key: "veranstaltung.bezeichnung", sortable: true, label: this.$t("global.shorteventormodule") },
        { key: "anreise", label: this.$t("global.arrival") },
        { key: "abreise", label: this.$t("global.departure") },
        { key: "naechte", label: this.$t("global.nights") },
        { key: "voranreise", label: this.$t("global.arrivaltheeveningbefore") },
      ];
    },
    queryParams() {
      return {
        filterPerson: this.setQueryParam(this.filters.person),
        gebaeude: this.setQueryParam(this.filters.gebaeude),
        filterVeranstaltung: this.setQueryParam(this.filters.veranstaltung),
        filterVon: this.setQueryParam(this.filters.von),
        filterBis: this.setQueryParam(this.filters.bis),
        reservationstyp: this.setQueryParam(this.filters.reservationstyp),
        voranreise: this.setQueryParam(this.filters.voranreise),
        offen: this.filters.offen ? "true" : null,
        filterCount: this.setQueryParam(this.filters.count),
      };
    },
  },
  created() {
    this.initFilter("zimmerreservation-liste", "liste-zimmerreservation/", true);
    if (this.gebaeude.length == 0) this.$store.dispatch(`ressourcen/${LADE_AUSWAHLWERTE_RESSOURCEN}`);
    AppApi.get("auswahlwerte/zimmer/")
      .then((response) => {
        this.reservationstypen = response.data.reservationstypen || [];
      })
      .catch((e) => this.$notify(apiErrorToAlert(e)));
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");
  },
  methods: {
    details(reservation) {
      this.$router.push({ name: "zimmerreservation", params: { id: reservation.id } });
    },
    /**
     * Rooming-Liste: alle Reservationen der aktuellen Filter (ohne Paging),
     * sortiert nach Hotel (offene zuletzt), Anreise und Person.
     */
    exportRoomingListe() {
      this.loading = true;
      const params = { ...this.queryParams, filterCount: null, export: "true" };
      AppApi.get("liste-zimmerreservation/", { params })
        .then((response) => {
          const datum = (d) => (d ? d.split(".").reverse().join("") : "");
          const hotelOffen = this.$t("global.hotelopen");
          const zeilen = (response.data || [])
            .slice()
            .sort((a, b) => {
              return (
                !a.gebaeude - !b.gebaeude ||
                (a.gebaeude?.bezeichnung || "").localeCompare(b.gebaeude?.bezeichnung || "") ||
                datum(a.anreise).localeCompare(datum(b.anreise)) ||
                (a.person?.bezeichnung || "").localeCompare(b.person?.bezeichnung || "")
              );
            })
            .map((r) => ({
              [this.$t("global.hotel")]: r.gebaeude?.bezeichnung || hotelOffen,
              [this.$t("global.person")]: r.person?.bezeichnung || "",
              [this.$t("global.reservationtype")]: r.reservationstyp?.bezeichnung || "",
              [this.$t("global.arrival")]: r.anreise || "",
              [this.$t("global.departure")]: r.abreise || "",
              [this.$t("global.nights")]: r.naechte,
              [this.$t("global.arrivaltheeveningbefore")]: r.voranreise ? this.$t("global.yes") : this.$t("global.no"),
              [this.$t("global.educationcourse")]: r.lehrgang?.bezeichnung || "",
              [this.$t("global.shorteventormodule")]: r.veranstaltung?.bezeichnung || "",
              [this.$t("global.nutrition")]: r.ernaehrung?.bezeichnung || "",
              [this.$t("global.allergies")]: r.allergien || "",
            }));
          if (zeilen.length == 0) {
            this.loading = false;
            this.$notify({ type: "warn", title: this.$t("global.export"), text: this.$t("global.nofurtherdatafound") });
            return;
          }
          this.exportToExcel(zeilen, this.$t("global.roomreservations"));
        })
        .catch((e) => {
          this.loading = false;
          this.$notify(apiErrorToAlert(e));
        });
    },
    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0) this.$bus.$emit("openLoeschenModal", "zimmerreservation-loeschen-modal");
    },
    loeschen() {
      AppApi.delete("zimmerreservation/", { params: { ids: this.selectedIds.join(",") } })
        .then(() => this.resetLoading(this))
        .catch((e) => this.$notify(apiErrorToAlert(e)));
    },
  },
};
</script>

<style></style>
